<template>
  <div class="carousel-container">
    <!-- 轮播轨道容器 -->
    <div
        class="carousel-track-container"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
        @mousedown="handleMouseDown"
        @mousemove="handleMouseMove"
        @mouseup="handleMouseUp"
        @mouseleave="handleMouseLeave"
    >
      <!-- 轮播轨道 -->
      <div
          class="carousel-track"
          :style="{
          transform: `translateX(${currentPosition}px)`,
          transition: isTransitioning ? 'transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)' : 'none'
        }"
      >
        <!-- 轮播项插槽 -->
        <slot></slot>
      </div>
    </div>

    <div style="height: 50px">
      <!-- 导航按钮 -->
      <button
          class="carousel-nav carousel-nav--prev"
          @click="prevSlide"
          :disabled="currentIndex === 0"
      >
        <i class="iconfont icon-xiangzuo1"></i>
      </button>
      <button
          class="carousel-nav carousel-nav--next"
          @click="nextSlide"
          :disabled="currentIndex >= slidesCount - 1"
      >
        <i class="iconfont icon-xiangyou1"></i>
      </button>
    </div>


    <!-- 指示器 -->
    <!--    <div class="carousel-indicators" v-if="slidesCount > 1">-->
    <!--      <button-->
    <!--          v-for="(slide, index) in slidesCount"-->
    <!--          :key="index"-->
    <!--          class="indicator"-->
    <!--          :class="{ 'indicator&#45;&#45;active': index === currentIndex }"-->
    <!--          @click="goToSlide(index)"-->
    <!--      ></button>-->
    <!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'AppleCarousel',
  data() {
    return {
      currentIndex: 0,
      currentPosition: 0,
      slideWidth: 0,
      slidesCount: 0,
      containerWidth: 0,
      startX: 0,
      currentX: 0,
      isDragging: false,
      isTransitioning: false,
      touchStartX: 0,
      touchMoveX: 0,
      dragOffset: 0,
      // 用于优化滑动体验的阈值
      minSwipeDistance: 50,
      swipeVelocityThreshold: 0.3
    };
  },
  mounted() {
    // 初始化轮播尺寸和位置
    this.$nextTick(() => {
      this.calculateDimensions();
      this.updatePosition();
      // 监听窗口大小变化，重新计算尺寸
      window.addEventListener('resize', this.handleResize);
    });

    // 监听插槽内容变化
    this.$watch(
        () => this.$slots.default,
        () => {
          this.$nextTick(() => {
            this.calculateDimensions();
            this.updatePosition();
          });
        }
    );
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 计算轮播尺寸
    calculateDimensions() {
      const container = this.$el.querySelector('.carousel-track-container');
      if (!container) return;

      this.containerWidth = container.offsetWidth;
      if (window.innerWidth < 768) {
        this.slideWidth = Math.round(this.containerWidth * 0.90); // 每个轮播项占70%宽度
      } else {
        this.slideWidth = Math.round(this.containerWidth * 0.60); // 每个轮播项占70%宽度
      }
      // 获取轮播项数量
      const slides = this.$el.querySelectorAll('.carousel-track > *');
      this.slidesCount = slides.length;

      // 为每个轮播项设置宽度和高度
      slides.forEach(slide => {
        slide.style.width = `${this.slideWidth}px`;
        if (window.innerWidth < 768) {
          slide.style.height = '500px'; // 设置高度为600px
        } else {
          slide.style.height = '600px'; // 设置高度为600px
        }
      });
    },

    // 更新轮播位置
    updatePosition() {
      // 计算居中偏移量
      const centerOffset = (this.containerWidth - this.slideWidth) / 40;
      this.currentPosition = -this.currentIndex * this.slideWidth + centerOffset;
    },

    // 窗口大小变化处理
    handleResize() {
      this.calculateDimensions();
      this.updatePosition();
    },

    // 上一张
    prevSlide() {
      if (this.currentIndex > 0) {
        this.isTransitioning = true;
        this.currentIndex--;
        this.updatePosition();
      }
    },

    // 下一张
    nextSlide() {
      if (this.currentIndex < this.slidesCount - 1) {
        this.isTransitioning = true;
        this.currentIndex++;
        this.updatePosition();
      }
    },

    // 跳转到指定幻灯片
    goToSlide(index) {
      if (index !== this.currentIndex && index >= 0 && index < this.slidesCount) {
        this.isTransitioning = true;
        this.currentIndex = index;
        this.updatePosition();
      }
    },

    // 触摸事件处理
    handleTouchStart(e) {
      this.isTransitioning = false;
      this.touchStartX = e.touches[0].clientX;
      this.startX = this.currentPosition;
      // 记录触摸开始时间用于计算滑动速度
      this.touchStartTime = Date.now();
    },

    handleTouchMove(e) {
      // 防止页面滚动
      e.preventDefault();
      this.touchMoveX = e.touches[0].clientX;
      this.dragOffset = this.touchMoveX - this.touchStartX;
      this.currentPosition = this.startX + this.dragOffset;
    },

    handleTouchEnd() {
      const touchEndTime = Date.now();
      const touchDuration = touchEndTime - this.touchStartTime;
      const swipeVelocity = Math.abs(this.dragOffset) / touchDuration;

      // 改进的滑动判定逻辑：距离或速度满足条件都可以触发切换
      let shouldChangeSlide = false;
      let direction = 0;

      if (Math.abs(this.dragOffset) > this.minSwipeDistance || swipeVelocity > this.swipeVelocityThreshold) {
        shouldChangeSlide = true;
        direction = this.dragOffset > 0 ? 1 : -1; // 1: 向左滑动，-1: 向右滑动
      }

      if (shouldChangeSlide) {
        if (direction > 0 && this.currentIndex > 0) {
          this.prevSlide();
        } else if (direction < 0 && this.currentIndex < this.slidesCount - 1) {
          this.nextSlide();
        } else {
          // 如果已经在边界，回弹
          this.isTransitioning = true;
          this.updatePosition();
        }
      } else {
        // 拖动距离不足，回弹
        this.isTransitioning = true;
        this.updatePosition();
      }

      this.dragOffset = 0;
    },

    // 鼠标事件处理（模拟触摸）
    handleMouseDown(e) {
      this.isDragging = true;
      this.isTransitioning = false;
      this.startX = this.currentPosition;
      this.currentX = e.clientX;
      this.mouseDownTime = Date.now();
      // 防止拖动时选中文本
      e.preventDefault();
    },

    handleMouseMove(e) {
      if (this.isDragging) {
        const diffX = e.clientX - this.currentX;
        this.currentPosition = this.startX + diffX;
      }
    },

    handleMouseUp() {
      if (this.isDragging) {
        this.isDragging = false;
        const diffX = this.currentPosition - this.startX;
        const mouseUpTime = Date.now();
        const mouseDuration = mouseUpTime - this.mouseDownTime;
        const mouseVelocity = Math.abs(diffX) / mouseDuration;

        let shouldChangeSlide = false;
        let direction = 0;

        if (Math.abs(diffX) > this.minSwipeDistance || mouseVelocity > this.swipeVelocityThreshold) {
          shouldChangeSlide = true;
          direction = diffX > 0 ? 1 : -1;
        }

        if (shouldChangeSlide) {
          if (direction > 0 && this.currentIndex > 0) {
            this.prevSlide();
          } else if (direction < 0 && this.currentIndex < this.slidesCount - 1) {
            this.nextSlide();
          } else {
            this.isTransitioning = true;
            this.updatePosition();
          }
        } else {
          this.isTransitioning = true;
          this.updatePosition();
        }
      }
    },

    handleMouseLeave() {
      if (this.isDragging) {
        this.handleMouseUp();
      }
    }
  }
};
</script>

<style scoped>
.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden; /* 隐藏容器的溢出内容，包括滚动条 */
  padding: 10px 0;
  //margin-top: 200px;
  background: #161617;
}

.carousel-track-container {
  width: 100%;
  overflow-x: hidden; /* 关键：隐藏水平滚动条 */
  overflow-y: visible; /* 允许垂直内容正常显示 */
  position: relative;
  touch-action: pan-y; /* 优化触摸体验 */
  -webkit-overflow-scrolling: touch;
  /* 额外添加以确保滚动条完全隐藏 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

/* 针对WebKit浏览器（Chrome, Safari）隐藏滚动条 */
.carousel-track-container::-webkit-scrollbar {
  display: none;
}

.carousel-track {
  display: flex;
  gap: 20px;
  padding: 10px 0;
  will-change: transform; /* 优化动画性能 */
}

/* 轮播项默认样式（可被覆盖） */
.carousel-track > * {
  background-color: #000;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
  /* 高度已在JS中设置为600px，这里作为备份 */
  //min-height: 600px;
}

/* 导航按钮 */
.carousel-nav {
  position: absolute;
  top: 96%;
  transform: translateY(-50%);
  background-color: #363638;
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #808080;
  font-size: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  z-index: 10;
}

.carousel-nav:hover {
  background-color: #646469;
}

.carousel-nav:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.carousel-nav--prev {
  right: 80px;
}

.carousel-nav--next {
  right: 20px;
}

/* 指示器 */
.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
}

.indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator--active {
  background-color: white;
  width: 24px;
  border-radius: 4px;
}
</style>
